import { mapDesigns } from "@mono/mapDesigns"
import { getUserCreds } from "./utils"

interface IPropertiesGroup {
  groupId: string
  properties: ICell[]
}
export const groupPropertiesByGroupId = (
  properties: ICell[]
): IPropertiesGroup[] => {
  const res: { [k in string]: ICell[] } = {}
  properties.forEach((property) => {
    if (!property?.propertyDetails?.groupId) return
    if (res[property.propertyDetails.groupId]) {
      res[property.propertyDetails.groupId].push(property)
    } else res[property.propertyDetails.groupId] = [property]
  })
  return Object.keys(res).map((groupId) => ({
    groupId,
    properties: res[groupId],
  }))
}
export const getAllUnsoldProperties = (
  mapId: string,
  allBoughtProperties: number[]
): ICell[] => {
  const map = mapDesigns.find((map) => map.id === mapId) as IMapDesign
  return map?.cells.filter(
    (cell) => cell.propertyDetails && !allBoughtProperties?.includes(cell.order)
  )
}
export const getUpdatedGameByTryingForDoubles = (
  gameid: string,
  roll: boolean
) => {}

export const getCurrentPlayer = (game: IGameDetails) =>
  game.situation?.players.find((player) => player.id === getUserCreds().email)

export const getOwnerOfProperty = (
  game: IGameDetails | undefined,
  propertyOrder: number
) =>
  game?.situation?.players.find((player) =>
    player.properties.includes(propertyOrder)
  )

export const getPlayerByPlayerOrder = (
  game: IGameDetails | undefined,
  playerOrder: number
) => game?.situation?.players.find((player) => player.order === playerOrder)
export const getMapById = (mapId: string) =>
  mapDesigns.find((map) => map.id === mapId)
export const getCellByOrderAndMapId = (cellOrder: number, mapId: string) => {
  const map = getMapById(mapId) as IMapDesign
  return map.cells.find((cell) => cell.order === cellOrder)
}

export const getPlayerByOrder = (game: IGameDetails, playerOrder: number) =>
  game.situation!.players.find((player) => player.order === playerOrder)
export const getUserByPlayerOrder = (
  game: IGameDetails,
  playerOrder: number
) => {
  const player = getPlayerByPlayerOrder(game, playerOrder) as IPlayer
  return game.players.find((user) => user.email === player.id)
}
export const getCellGroup = (mapId: string, cell: ICell) => {
  const map = getMapById(mapId) as IMapDesign
  return map.groups.find((group) => group.id === cell.propertyDetails?.groupId)
}
